//时间转换
function tsToTime(timestamp, hasSecond = true) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '.';
    var M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '.';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    var s =
        ':' +
        (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    if (hasSecond) {
        return Y + M + D + h + m + s;
    } else {
        return Y + M + D + h + m;
    }
}

function getWeek(timeStamp) {
    var date = new Date(timeStamp * 1000);
    var day = date.getDay();
    if (day == 0) {
        return '周日';
    } else if (day == 1) {
        return '周一';
    } else if (day == 2) {
        return '周二';
    } else if (day == 3) {
        return '周三';
    } else if (day == 4) {
        return '周四';
    } else if (day == 5) {
        return '周五';
    } else if (day == 6) {
        return '周六';
    }
    return '';
}

// 2019-6-24
function timestampToDay(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-';
    var D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    return Y + M + D;
}

/**
 * 时间戳 => 10-10
 * */
function timestampToMD(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '.';
    var D =
        (date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    return M + D;
}

/**
 * 时间戳 => 10:10
 * */

function timestampToHM(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var h =
        (date.getHours() + 1 < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m =
        date.getMinutes() + 1 < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return h + m;
    // return Y + M + D;
}

/**
 * 时间戳 =>判断时间戳区间（ 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年 ）
 * */
function time_judge(time_start, time_end) {
    var time_s = new Date(time_start * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var time_e = new Date(time_end * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var today = new Date(); //当前时间
    var Y_s = time_s.getFullYear() + '.';
    var Y_e = time_e.getFullYear() + '.';
    var Y_n = today.getFullYear() + '.';
    var M_s =
        (time_s.getMonth() + 1 < 10 ?
            '0' + (time_s.getMonth() + 1) :
            time_s.getMonth() + 1) + '.';
    var M_e =
        (time_e.getMonth() + 1 < 10 ?
            '0' + (time_e.getMonth() + 1) :
            time_e.getMonth() + 1) + '.';
    var D_s =
        (time_s.getDate() + 1 < 10 ? '0' + time_s.getDate() : time_s.getDate()) +
        ' ';
    var D_e =
        (time_e.getDate() + 1 < 10 ? '0' + time_e.getDate() : time_e.getDate()) +
        ' ';
    //判断
    if (Y_s == Y_e) {
        //同年
        if (Y_s == Y_n) {
            //今年
            if (M_s == M_e && D_s == D_e) {
                //今年不跨日
                return 0;
            } else {
                //今年跨日
                return 1;
            }
        } else {
            //往年
            if (M_s == M_e && D_s == D_e) {
                //往年不跨日
                return 2;
            } else {
                //往年跨日
                return 3;
            }
        }
    } else {
        //跨年
        return 4;
    }
}

// 获取时间跨度
function getDuration(start_date, end_date) {
    let dateStr;
    // 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年
    const type = time_judge(start_date, end_date);
    switch (type) {
        case 0:
            {
                dateStr =
                timestampToMD(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToHM(end_date);
            }
            break;
        case 1:
            {
                dateStr =
                timestampToMD(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToMD(end_date) +
                timestampToHM(end_date);
            }
            break;
        case 2:
            {
                dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToHM(end_date);
            }
            break;
        case 3:
            {
                dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToMD(end_date) +
                timestampToHM(end_date);
            }
            break;
        case 4:
            {
                dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToDay(end_date) +
                timestampToHM(end_date);
            }
            break;
        default:
            dateStr = '不支持的时间格式';
            break;
    }
    return dateStr;
}

function debounce(func, wait) {
    let timeout;
    return function() {
        let context = this;
        let args = arguments;

        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(() => {
            func.apply(context, args)
        }, wait);
    }
}

// 获取字母序号 number >= 1
function getLetterNumber(number) {
    return String.fromCharCode(64 + number);
}

function toFixed(num, s) {
    var times = Math.pow(10, s)
    var des = num * times + 0.5
    des = parseInt(des, 10) / times
    return des + ''
}

// 数组元素交换
function swapArrayItem(arr, fromIndex, toIndex) {
    arr[toIndex] = arr.splice(fromIndex, 1, arr[toIndex])[0];
    return arr;
}

// 获取当前时间戳，单位秒
function getCurTimestamp() {
    return parseInt(new Date().getTime() / 1000);
}

export default {
    tsToTime,
    getWeek,
    timestampToDay,
    timestampToMD,
    timestampToHM,
    time_judge,
    getDuration,
    debounce,
    getLetterNumber,
    toFixed,
    swapArrayItem,
    getCurTimestamp
};